import actionTypes from '../actionTypes';
export default {
  liveAgentList: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_AGENT_LIST,
      payload: data
    });
  },
  liveFilter: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_FILTER,
      payload: data
    });
  },
  liveStateList: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_STATE_LIST,
      payload: data
    });
  },
  liveQueue: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_QUEUE,
      payload: data
    });
  },
  setLiveAgentList: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_SET_AGENT_LIST,
      payload: data
    });
  },
  setLiveFilter: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_SET_FILTER,
      payload: data
    });
  },
  setLiveStateList: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_SET_STATE_LIST,
      payload: data
    });
  },
  setLiveQueue: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_SET_QUEUE,
      payload: data
    });
  },
  dynamicUpdate: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_DYNAMIC_UPDATE,
      payload: data
    });
  },
  updateLiveChatData: data => dispatch => {
    dispatch({
      type: actionTypes.UPDATE_LIVE_CHAT_DATA,
      payload: data
    });
  },
  liveTranscriptionSet: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.LIVE_TRANSCRIPTION_SET,
      payload: data,
    });
  },
  liveTranscriptionUpdate: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.LIVE_TRANSCRIPTION_UPDATE,
      payload: data,
    });
  },
  clearLiveTranscription: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.LIVE_CLEAR_TRANSCRIPTION,
      payload: data,
    });
  },
  liveSummarySet: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.CHAT_SUMMARY,
      payload: data,
    });
  },
  setChatSummaryLoading: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.CHAT_SUMMARY_LOADING_SET,
      payload: data,
    });
  },
  clearChatSummary: (data) => (dispatch) => {
      dispatch({
        type: actionTypes.CHAT_SUMMARY_CLEAR,
        payload: data,
      });
    },
};



// WEBPACK FOOTER //
// src/store/action/livemonitor.action.js